import { Fund } from 'src/components/Exchange/types';
import {
  BUY_TRANSACTION,
  EXCHANGE_TRANSACTION,
  SELL_TRANSACTION,
} from '../../../settings/settings';

/**
 * @desc Function that adds recurring transactions for a specific fund to an array that is attached to the
 *       fund object wherever this function is called.
 * @param {*} fund fund object
 * @param {*} automaticTransactions RecurringBuy, RecurringSell, AutoExchange and Automax transactions
 * @return {Array} List of transaction types associated with that fund
 */
export const getRecurringTransactionsForFund = (
  fund: Fund,
  automaticTransactions
) => {
  const { autoExchanges, recurringPurchases, recurringRedemptions } =
    automaticTransactions;
  const recurringTransactionTypes: string[] = [];
  if (autoExchanges[fund.agreementID]) {
    recurringTransactionTypes.push(EXCHANGE_TRANSACTION);
  }
  if (recurringPurchases[fund.agreementID]) {
    recurringTransactionTypes.push(BUY_TRANSACTION);
  }
  if (recurringRedemptions[fund.agreementID]) {
    recurringTransactionTypes.push(SELL_TRANSACTION);
  }
  return recurringTransactionTypes;
};
